import service from '@/services/superaccess'

const users = {
  state: {
    modal: false
  },
  mutations: {
    setModalStatus (state, status) {
      state.modal = status
    }
  },
  getters: {
    getModalStatus (state) {
      return state.modal
    }
  },
  actions: {
    changeModalStatus (context, payload) {
      context.commit('setModalStatus', payload)
    },
    changeStateUser (context, payload) {
      return service.patch('/api/user/change/', context, payload)
    },
    modifyUser (context, payload) {
      return service.patch('/api/user/modify/', context, payload)
    },
    registerUser (context, payload) {
      return service.post('/api/user/create', context, { user: payload })
    },
    retrieveDetailsForm (context, payload) {
      return service.get('/api/user/new', context)
    },
    retrieveDetailsUser (context, payload) {
      return service.get(`/api/user/${payload}`, context)
    },
    retrieveCompaniesByUser (context, payload) {
      return service.get('/api/user/companies', context)
    },
    validateEmailUser (context, payload) {
      return service.post('/api/user/check-email/', context, payload)
    }
  }
}

export default users



// WEBPACK FOOTER //
// app/javascript/src/store/users.js